import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import { OrganizationInvitesState } from 'src/app/OrganizationInvites/redux/organizationInvites.reducer'
import {
  ManageOrgInviteMatchParams,
  manageOrgInviteRouteProps,
} from 'src/navigation/routeProps'
import { RootState } from 'src/redux/createRootReducer'
import { selectOrganizationInvitesModelsFromState } from 'src/redux/selectors/data/organizations.selectors'
import { selectLocationFromState } from 'src/redux/selectors/router.selectors'

export const selectFetchingInvites = (state: RootState): boolean =>
  state.app.organizationInvites.fetchingInvites

export const selectOrganizationInvites = (
  state: RootState,
): OrganizationInvitesState => state.app.organizationInvites

export const selectPostingOrganizationInvitesFromState = (
  state: RootState,
): boolean => state.app.organizationInvites.postingOrganizationInvites

export const selectPostInvitesTopLevelErrorFromState = (
  state: RootState,
): string | undefined => state.app.organizationInvites.postInvitesTopLevelError

export const selectPatchingOrganizationInviteFromState = (
  state: RootState,
): boolean => state.app.organizationInvites.patchingOrganizationInvite

export const selectPatchingOrganizationInviteTopLevelErrorFromState = (
  state: RootState,
): string | undefined =>
  state.app.organizationInvites.patchingOrganizationInviteTopLevelError

export const selectPatchComplete = (state: RootState): boolean =>
  state.app.organizationInvites.patchComplete

export const selectOrganizationInviteIdFromRoute = createSelector(
  [selectLocationFromState],
  (location) => {
    const mtch = matchPath<ManageOrgInviteMatchParams>(
      location.pathname,
      manageOrgInviteRouteProps,
    ) as match<ManageOrgInviteMatchParams>
    return mtch.params.id
  },
)

const selectUniqueOrganizationInviteIds = createSelector(
  [selectOrganizationInvites],
  (data) => data.ids.filter((id, i) => data.ids.indexOf(id) === i),
)

export const selectUniqueOrganizationInviteModels = createSelector(
  [selectUniqueOrganizationInviteIds, selectOrganizationInvitesModelsFromState],
  (ids, invites) => {
    return ids.map((id) => invites[id]).filter((id) => id !== undefined)
  },
)

export const selectFilteredOrganizationInviteModels = createSelector(
  [selectUniqueOrganizationInviteModels],
  (invites) => invites.filter(() => true),
)
